import React, { useState } from 'react';
import { Input } from 'antd';
import Button from '../button';
import Wrapper from './style';

const Index = (props) => {
  const { handleChange, placeholder, minWidth } = props;
  const [tempKeyword, setTempKeyword] = useState('');

  return (
    <Wrapper minWidth={minWidth} className="component_tableFilter_search">
      <Input
        value={tempKeyword}
        placeholder={placeholder || 'placeholder'}
        onChange={(e) => {
          setTempKeyword(e.target.value);
        }}
      />
      <div className="buttons-wrapper">
        <Button
          onClick={() => {
            setTempKeyword('');
            handleChange('');
          }}
          type="secondary"
        >
          Reset
        </Button>
        <Button
          type="primary"
          onClick={() => {
            handleChange(tempKeyword);
          }}
        >
          Search
        </Button>
      </div>
    </Wrapper>
  );
};

export default Index;
